import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "../utils/language"

const socialLinks = [
  { href: "https://www.youtube.com/@regisatemengue", icon: ["fab", "youtube"], cls: "youtube", title: "YouTube" },
  { href: "https://www.github.com/atemengue", icon: ["fab", "github"], cls: "github", title: "GitHub" },
  { href: "https://linkedin.com/in/regis-atemengue/", icon: ["fab", "linkedin"], cls: "linkedin", title: "LinkedIn" },
  { href: "https://www.twitter.com/regis_ate", icon: ["fab", "twitter"], cls: "twitter", title: "Twitter" },
  { href: "https://www.tiktok.com/@regisatemengue", icon: ["fab", "tiktok"], cls: "tiktok", title: "TikTok" },
  { href: "mailto:moafembe@gmail.com", icon: ["fas", "envelope"], cls: "mail", title: "Email" },
]

export default () => {
  const { author } = useStaticQuery(query).site.siteMetadata
  const { t } = useTranslation()

  return (
    <div className="footer-parent">
      <Container>
        <div className="footer text-muted p-2">
          <Row className="align-items-center">
            <Col md="6" className="text-md-left text-center mb-2 mb-md-0">
              <span>
                <a href="https://www.regisatemengue.com/bio" target="_blank" rel="noopener noreferrer">
                  {author}
                </a>
                {" "}©{new Date().getFullYear()}.
              </span>
              <div>
                <span>{t("footer.rights")}</span>
              </div>
            </Col>
            <Col md="6" className="text-md-right text-center">
              <div className="d-inline-flex align-items-center icons-container">
                {socialLinks.map(({ href, icon, cls, title }) => (
                  <a
                    key={title}
                    href={href}
                    target={href.startsWith("mailto:") ? undefined : "_blank"}
                    rel={href.startsWith("mailto:") ? undefined : "noopener noreferrer"}
                    title={title}
                  >
                    <FontAwesomeIcon
                      size="2x"
                      icon={icon}
                      className={`icons ${cls}`}
                      title={title}
                    />
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  )
}

const query = graphql`
  query Author {
    site {
      siteMetadata {
        author
      }
    }
  }
`
